export const products_promo_card: Record<string, string> = {
  products_promo_card_title: 'products-promo-card-title',
  products_promo_card_description: 'products-promo-card-description',
  products_promo_card_call_to_action: 'products-promo-card-call-to-action',
};

export const financial_advice_promo_card: Record<string, string> = {
  financial_advice_promo_card_title: 'financial-advice-promo-card-title',
  financial_advice_promo_card_description:
    'financial-advice-promo-card-description',
  financial_advice_promo_card_call_to_action:
    'financial-advice-promo-card-call-to-action',
};

export const resources_promo_card: Record<string, string> = {
  resources_promo_card_description: 'resources-promo-card-description',
  resources_promo_card_title: 'resources-promo-card-title',
  resources_promo_card_call_to_action: 'resources-promo-card-call-to-action',
};
